import {CoordinateLonLat} from "../utils.ts";
import {User} from "./player.ts";
import {save, load} from "./storage.ts";

export type Quest = {
    id: string;
    title: string;

    beginStep: QuestStep;

    state: QuestState;
}

export type QuestState = {
    state: "completed" | "running" | "unavailable" | "available";
    runedAt: Date | null;
    completedAt: Date | null;
}

export type QuestStep = {
    id: string;
    nextStep: QuestStep | null;

    title: string | null;

    locations: {
        coordinate: CoordinateLonLat;
        activationRadius: number;
        activationCondition: LocationActivationCondition;
        scenario: Scenario;
    }[];
}

export type Dialog = {
    withPerson: string;

    parts: DialogParts[];
}

export type ScenarioKind = "run-dialog";
export type LocationActivationCondition = "auto" | "prompt";

export type Scenario = {
    id: string;
    title: string;

    kind: "run-dialog";

    dialog: Dialog;
}

export type DialogParts = {

}

export function getQuests(): Quest[] {
    return [
        {
            id: "near_railroad",
            title: "У железной дороги",
            beginStep: {
                id: "near_railroad_step_1",
                title: null,
                locations: [
                    {
                        coordinate: { lon: 30.420550, lat: 59.739043},
                        activationRadius: 2,
                        activationCondition: "prompt",
                        scenario: {
                            id: "near_railroad_scenario_1",
                            kind: "run-dialog",
                            title: "Idk",
                            dialog: {
                                withPerson: "Beaver",
                                parts: []
                            },
                        }
                    }
                ],
                nextStep: null,
            },
            state: {
                state: "available",
                runedAt: null,
                completedAt: null,
            }
        }
    ]
}

export type UserQuestState = {
    questId: string;
    currentStepId: string | null;
    state: "completed" | "running" | "unavailable" | "available";
    runedAt: Date | null;
    completedAt: Date | null;
}

async function initQuests(): Promise<UserQuestState[]> {
    const questStates: UserQuestState[] = [
        {
            questId: "near_railroad",
            currentStepId: "near_railroad_step_1",
            state: "available",
            runedAt: null,
            completedAt: null,
        }
    ];

    await save("questStates", questStates);

    return questStates;
}

export async function getAvailableAndActiveSteps(user: User): Promise<UserQuestState[]> {
    return await load<UserQuestState[]>("questStates") ?? await initQuests();
}

function tryFindStep(questStep: QuestStep, stepId: string): QuestStep | null {
    if (questStep.id === stepId) {
        return questStep;
    }

    if (questStep.nextStep === null) {
        return null;
    }

    return tryFindStep(questStep.nextStep, stepId);
}

export function getStepsForUserQuestState(uqs: UserQuestState[]): QuestStep[] {
    const steps: QuestStep[] = [];

    const allQuests = getQuests();

    for (const quest of allQuests) {
        for (const uq of uqs) {
            if (uq.currentStepId === null) {
                continue;
            }

            if (quest.id === uq.questId) {
                const step = tryFindStep(quest.beginStep, uq.currentStepId);

                if (step === null) {
                    throw new Error("unable to find step id ");
                }

                steps.push(step);
            }
        }
    }

    return steps;
}